export default __webpack_public_path__ + "static/media/refer-friend.86a993c3.svg";